<template>
  <button
    type="button"
    class="template_link"
    :class="{
      template_link_input: asInput && !iconOnly,
      template_link_icon_only: iconOnly,
      is_empty: !clickable
    }"
    :title="linkTitle"
    :disabled="!clickable"
    @click.stop.prevent="open"
  >
    <span class="template_link_text" v-if="!iconOnly">{{ displayName }}</span>
    <svg
      class="template_link_icon"
      width="11"
      height="11"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2.4"
      stroke-linecap="round"
      stroke-linejoin="round"
      v-if="clickable || iconOnly"
    >
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  </button>
</template>

<script>
// 템플릿명을 눌러 해당 템플릿을 팝업으로 조회·수정할 수 있게 하는 공용 링크.
// templateId 를 모를 때는 템플릿명으로 스토어에서 찾아 연다.
const TYPE_LABEL = {
  image: '상품 템플릿',
  word: '단어설정 템플릿',
  upload: '마진 템플릿'
};

export default {
  name: 'TemplateLink',
  props: {
    // 'image' (상품/상세) | 'word' (단어설정) | 'upload' (마진)
    type: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    templateId: {
      type: [String, Number],
      default: ''
    },
    // 리스트의 readonly input 자리에 들어갈 때 (테두리 있는 형태)
    asInput: {
      type: Boolean,
      default: false
    },
    // 이미 select 등으로 템플릿명이 보이는 곳 : 아이콘 버튼만 노출
    iconOnly: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: '-'
    }
  },
  computed: {
    displayName() {
      return this.name && this.name !== '-' ? this.name : this.emptyText;
    },
    typeLabel() {
      return TYPE_LABEL[this.type] ?? '템플릿';
    },
    // 템플릿명이 없거나 삭제된 템플릿이면 열 수 없다.
    clickable() {
      if (!this.name || this.name === '-') return false;
      if (this.name.includes('삭제된 템플릿')) return false;
      return true;
    },
    linkTitle() {
      if (!this.clickable) {
        return this.iconOnly ? `${this.typeLabel}을 먼저 선택해주세요.` : this.displayName;
      }
      return `${this.typeLabel} 조회/수정 : ${this.name}`;
    }
  },
  methods: {
    open() {
      if (!this.clickable) return;
      this.templateStore.openTemplateViewer({
        type: this.type,
        templateId: this.templateId,
        templateName: this.name
      });
    }
  }
};
</script>
